function Body() {
	return (
		<div className='max-w-4xl m-auto bg-primary rounded-lg'>
			<div className='md:p-10 p-8'>
				<h2 className='text-center text-2xl italic text-yellow-500 font-bold '>
					<span className=''>WELCOME TO OUR ALGAE LAB!</span>
				</h2>
				<br />
				<div className='text-center'>
					Peninsular India has a very long coastline and plenty of
					inland water bodies, which harbours rich marine and
					freshwater algal diversity. It provides the greatest
					opportunity study of biodiversity, ecology and its
					applications in various fields.
				</div>
				<br />
				<div className='text-center'>
					Currently we are focusing and carrying out research in the
					area of:
				</div>
				<br />

				<div className=' text-center'>
					<div className='md:grid md:grid-rows-1 text-black font-semibold md:grid-flow-col'>
						<div className='bg-gray-200  rounded-lg m-4 p-5 transition duration-500 ease-in-out hover:bg-yellow-500 transform hover:-translate-y-1 hover:scale-110'>
							<h5 className="font-bold text-lg">Freshwater Diatom Flora of Tamil Nadu</h5>
							<br />
							<p className='font-semibold'>
								Studies on the freshwater diatom flora of Tamil
								Nadu has been initiated and is under progress.
							</p>
						</div>
						<div className='bg-gray-200  rounded-lg m-4 p-5 transition duration-500 ease-in-out hover:bg-yellow-500 transform hover:-translate-y-1 hover:scale-110'>
							<h5 className="font-bold text-lg">Taxonomy of Marine and Fresh Water Algae</h5>
							<br />
							<p className='font-semibold text-base'>
								Studies on the Diversity of Freshwater and
								Marine algal flora of Tamil Nadu has been
								initiated.
							</p>
						</div>
						<div className='bg-gray-200  rounded-lg m-4  p-5 transition duration-500 ease-in-out hover:bg-yellow-500 transform hover:-translate-y-1 hover:scale-110'>
							<h5 className="font-bold text-lg">Water Quality Assessment</h5>
							<br />
							<p className='font-semibold text-base'>
								Studies on Water Pollution and Water Quality
								Assessment using freshwater Diatoms as a
								Pollutions Indicator has been carried out in
								several districts of Tamil Nadu.
							</p>
						</div>
					</div>
					<div className='md:grid md:grid-rows-1 md:grid-flow-col  text-black font-semibold'>
						<div className='bg-gray-200  rounded-lg m-4  p-5 transition duration-500 ease-in-out hover:bg-yellow-500 transform hover:-translate-y-1 hover:scale-110'>
							<h5 className="font-bold text-lg">Biodegradation of Environmental Pollutants</h5>
							<br />
							<p className='font-semibold text-base'>
								Biodegradation pathway of phthalate esters (DBP,
								DPP, DEP and DMP) was carried out using
								different strains of freshwater algae.
							</p>
						</div>
						<div className='bg-gray-200  rounded-lg m-4  p-4 transition duration-500 ease-in-out hover:bg-yellow-500 transform hover:-translate-y-1 hover:scale-110'>
							<h5 className="font-bold text-lg">
								Isolation &amp; Purification of Bioactive
								Compounds from Algae
							</h5>
							<br />
							<p className='font-semibold text-base'>
								The bioactive compounds from microalgae have
								been investigated for antioxidant, antimicrobial
								and anticancer activities
							</p>
						</div>
						<div className='bg-gray-200  rounded-lg m-4 p-5 transition duration-500 ease-in-out hover:bg-yellow-500 transform hover:-translate-y-1 hover:scale-110'>
							<h5 className="font-bold text-lg">Phycosynthesis of Nanoparticle</h5>
							<br />
							<p className='font-semibold text-base'>
								Studies on the synthesis of Silver and Gold
								nanoparticles using various marine and
								freshwater algae have been carried out to
								evaluate the potential role of microalgae in
								Pharmaceuticals.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Body;
